export const redirectionUrls = {
    sellerAppGooglePlayStore:
      'https://play.google.com/store/apps/details?id=com.amazon.sft.rangoli.seller.app',
    faqPage: 'https://smartbiz-support.zendesk.com/hc/en-us/sections/15674324808593-Select-a-Section',
    howToGuide: 'https://smartbiz-support.zendesk.com/hc/en-us',
    frequentlyAsked: 'https://help.smartbiz.in/hc/en-us/sections/18491586242321-FAQs',
    termsAndConditionUrl: 'https://smartcommerce.amazon.in/terms-of-use',
    privacyPolicyUrl: 'https://smartcommerce.amazon.in/privacy-policy',
  };